import React from 'react';
import { Route } from 'react-router-dom';
import Configuration from './configuration/Configuration';
// import Register from './auth/Register';

export default [
    <Route exact path="/configuration" component={Configuration} />,
    // <Route exact path="/register" component={Register} />,
];